import Button from 'atoms/Button';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStore } from 'stores/store';

import s from './SwitchMapViewButton.module.scss';

const SwitchMapViewButton = () => {
  const { AssetStore } = useStore();

  const setMapView = () => {
    AssetStore.setAssetBrowsingTableView(false);
    AssetStore.setAssetBrowsingMapView(!AssetStore.assetBrowsingView.assetBrowsingMapView);
  };

  return (
    <Button
      size="small"
      className={cn(s.SwitchMapViewButton, {
        isActive: AssetStore.assetBrowsingView.assetBrowsingMapView
      })}
      variant="outlined"
      onClick={setMapView}
      aria-label="Switch View"
    />
  );
};

export default observer(SwitchMapViewButton);
